module.exports = __webpack_public_path__ + "assets/img/reminder-detail-2.cf9ff37d.png";